export default __webpack_public_path__ + "static/naming-convention-23915e83b53c931d1501fef10329f194.svg";